import Vue from 'vue';
import { ValidationProvider, ValidationObserver, extend, localize } from 'vee-validate';
import * as originalRules from 'vee-validate/dist/rules';
import ja from 'vee-validate/dist/locale/ja.json';
import isCreditCard from 'validator/lib/isCreditCard';
import { dayjsWapper } from '~/utils/tool'

// 全てのルールをインポート
console.log("originalRules",originalRules)
let rule;
for (rule in originalRules) {
  extend(rule, {
    ...originalRules[rule], // eslint-disable-line
  });
}
extend('credit_card', {
  validate: (val) => isCreditCard(val),
  message: 'カード番号の形式が不正です'
});

extend('future_day', {
  validate: (value) => {
    if (dayjsWapper() > dayjsWapper(value)){
      return false
    }else{
      return true
    }
  },
  message: "未来日を設定してください",
});

extend('day_after_start_day', {
  params: ['target'],
  validate(value, { target }) {
    if (dayjsWapper(value) > dayjsWapper(target)){
      return true
    }else{
      return false
    }
  },
  message: '終了日は開始日よりも未来日にしてください'
});

// 小数点を含む数値のバリデーター
extend('decimal', {
  params: ['decimals', 'separator'],
  validate(value, { decimals, separator = '.' }) {
    if (!value) return true; // 空の値は他のバリデーターで処理
    
    const regex = new RegExp(`^\\d+\\${separator}\\d{1,${decimals || 3}}$|^\\d+$`);
    return regex.test(String(value));
  },
  message: '{_field_}は有効な数値を入力してください'
});

// extend("before", {
//   params: ["target"],
//   validate: (value, params) => {
//     const target = params["target"];
//     const date1 = dayjsWapper(value);
//     const date2 = dayjsWapper(target);
//     if (!date2 || !date1) return false;
//     return date2.isAfter(date1);
//   },
//   message: "{_field_}は、{target}より前の日付を入力ください"
// });

extend("after", {
  params: ["target"],
  validate: (value, params) => {
    const target = params["target"];
    const date1 = dayjsWapper(value);
    const date2 = dayjsWapper(target);
    if (!date1 || !date2) return false;
    return date1.isAfter(date2);
  },
  message: "{_field_}は、{target}より後の日付を入力ください"
});

// パスワードポリシーのカスタムバリデーションルール
extend('password_policy', {
  validate: (value) => {
    if (!value) return false
    const hasLength = value.length >= 8
    const hasAlphanumeric = /^(?=.*[a-zA-Z])(?=.*\d)/.test(value)
    return hasLength && hasAlphanumeric
  },
  message: 'パスワードポリシーを満たしていません（8文字以上、英数字混合）'
})

// メッセージを設定
localize('ja', ja);

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
